import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import get from 'lodash/get';

import has from 'lodash/has';
import isString from 'lodash/isString';
import set from 'lodash/set';
import omit from 'lodash/omit';

import without from 'lodash/without';
import isObject from 'lodash/isObject';
import upperFirst from 'lodash/upperFirst';


import { generatePath, matchPath } from 'react-router';
import { formatMultiArrayForURL, normalizeString as normalizeMake } from '@dmm/lib-common/lib/formatting';
import { getCurrentBoats as bts, getCurrentRoutes as rts, formatMessage as t, mappedValue } from '../language';
import { sortTypeMap, getDefaultEnginesSort } from '../sortHelper';
import { multiFacetUrlToObject, multiFacetUrlToArray, toggleSubFacet } from '../multiFacetHelper';
import messages from '../translationMessages';
import { normalizeString, translateMake } from '../commonHelper';
import { getCurrentLocale } from '../language';
import { getCurrencyFormat, getCurrencySymbol, getCurrencyCode } from '../uomHelper';
import { getBoatsConstants } from '../../constants/boats/index';
import { getConfig } from '../../config/portal';
export const slugify = (string, joiner = '+') => isString(string) ? string.toLowerCase().split(' ').join(joiner) : '';
export const unslugify = (string, splitter = '+', joiner = ' ') => string.toLowerCase().split(splitter).join(joiner);

export const searchPathIsActive = () => false;

export const searchBrandedPathIsActive = url =>
  !!matchPath(decodeURI(url), bts().ENGINES_BRANDED_SEARCH_URL_PATTERN);

export const hyphenateUrlComponents = (string, removeSpecialCharacters = true) => {
  if (!isString(string)) {return '';}
  string = string.toLowerCase();
  // Remove accents and special characters
  if (removeSpecialCharacters) {
    string = normalizeString(string);
    const validChars = new RegExp(`[^${getBoatsConstants().ALLOWED_CHARACTERS_IN_URL}]+`, 'g');
    string = string.replace(validChars, ' ');
  }
  string = string.replace(/[ ]+/g, ' ');
  string = string.split('&').join('$');
  string = string.split('-').join('--');

  string = slugify(string, '-');
  string = string.replace(/-$/, '');
  string = string.replace(/^-/, '');
  return string;
};

export const initializeGlobalCountriesURLs = (locale = '') => {
  if (locale.length === 2) {
    if (!get(global, `url.${locale}`)) { set(global, `url.${locale}`, {}); }
    if (!global.url[locale].countries) {
      // Can't use this as this only contains the information for the current language, and we need this to be dynamic.
      const countriesFromTranslation = require('../language').translationMessages[locale];
      let countries = [];
      let country = '';
      for (let prop in countriesFromTranslation) {
        if (prop === 'routes.search.item.country') { country = countriesFromTranslation[prop]; }
        if (prop.match(/app.countries.([A-Z]{2})/g)) {
          try {
            const countryTranslatedName = hyphenateUrlComponents(countriesFromTranslation[prop]);
            countries.push({
              code: prop.replace('app.countries.', '').toLowerCase(),
              url: countryTranslatedName.trim()
            });
          } catch (e) {
            // Comment to avoid the empty block statement :(
          }
        }
      }
      global.url[locale].country = country;
      global.url[locale].countries = countries;
    }
  }
};

export const getCountryCodeFromURL = (url, overrideLocale) => {
  if (url) {
    const locale = overrideLocale ? overrideLocale : getCurrentLocale();
    initializeGlobalCountriesURLs(locale);
    const prefix = global.url[locale].country;
    const prefixRegExp = new RegExp(`${prefix}-`);
    const urls = global.url[locale].countries.filter(country => {
      return country.url === (url).replace(prefixRegExp, '');
    });
    return (urls.length > 0) ? `${prefix}-${urls[0].code}` : url;
  }
  return url;
};

export const getCountryURLFromCode = (code, overrideLocale) => {
  if (code) {
    const locale = overrideLocale ? overrideLocale : getCurrentLocale();
    initializeGlobalCountriesURLs(locale);
    const prefix = global.url[locale].country;
    const urls = global.url[locale].countries.filter(country => {
      const prefixRegExp = new RegExp(`${prefix}-`, 'g');
      return country.code === (code).replace(prefixRegExp, '');
    });
    return (urls.length > 0) ? `${prefix}-${urls[0].url}` : code;
  }
  return code;
};

const generateMakeAndModelPathParam = (makeModel) => {
  let makes = Object.keys(makeModel).length;
  if (makes === 1) {
    let models = 0;
    Object.values(makeModel).map( item => {
      models += item.length;
    });
    if (models < 2) {
      let make = Object.keys(makeModel)[0];
      let makeMod = { 'make': make };
      if (models === 1) {
        makeMod.model = makeModel[make][0];
      }
      return makeMod;
    }
  }
  return null;
};

export const getEnginesDealerGalleryPattern = (cfg, bt, owner, dealerStr) => {
  const re = new RegExp(`${dealerStr}-(.*)`);
  const dealerPrefix = re.test(owner);
  const searchPattern = dealerPrefix ?
    bt.GENERATE_ENGINES_DEALER_GALLERY_URL_PATTERN :
    bt.GENERATE_ENGINES_BRANDED_SEARCH_URL_PATTERN;
  return searchPattern;
};

export const generateSearchPath = (changes, urlProps, newSearch, overrideLocale) => {
  // locale is overriden only in translating location
  const config = rts(overrideLocale);
  const bt = bts(overrideLocale);
  const tr = (message, params) => t(message, params, overrideLocale);
  let removeLastSlash = false;

  let initialParams = {
    ...urlProps,
    ...changes
  };

  let finalParams = {};

  if (initialParams.modal) {
    delete initialParams.modal;
  }

  if (initialParams.makeModel) {
    if (!isEmpty(initialParams.makeModel)) {
      let seperateMakeModel = generateMakeAndModelPathParam(initialParams.makeModel);
      if ( seperateMakeModel ) {
        finalParams.make = `${config.SEARCH_URL_ITEM_MAKE}-${seperateMakeModel.make}`;
        if (seperateMakeModel.model) {
          finalParams.model = `${config.SEARCH_URL_ITEM_MODEL}-${seperateMakeModel.model}`;
        }
      }
      else {
        const models = flatten(Object.keys(initialParams.makeModel)
          .map(makeName => {
            const models = Object.values(get(initialParams.makeModel, makeName, []));
            if (models.length) {
              return models.map(modelName => {
                return `${makeName}:${modelName}`;
              });
            }
            return makeName;
          })).filter(makeModel => !!makeModel);
        finalParams.makeModel = `${config.SEARCH_URL_ITEM_MAKEMODEL}-${models.join('+')}`;
      }
    }
    delete initialParams.makeModel;
  }

  if (initialParams.sort) {
    const [sortBy, sortOrder] = initialParams.sort.split(':');
    const translatedSort = `${tr(messages.search[sortBy])}:${tr(messages.sortFacet[sortOrder])}`;
    finalParams.sort = `${config.SEARCH_URL_ITEM_SORT}-${translatedSort}`;
    delete initialParams.sort;
  }

  if (initialParams.condition) {
    if (initialParams.condition !== 'any') {
      const translatedCondition = tr(messages.conditionFacet[initialParams.condition]);
      finalParams.condition = `${config.SEARCH_URL_ITEM_CONDITION}-${translatedCondition}`;
    }
    delete initialParams.condition;
  }

  if (initialParams.keyword) {
    if (initialParams.searchKeywordParamFormat && initialParams.searchKeywordParamFormat === 'query-string') {
      removeLastSlash = true;
      finalParams.keyword = `?${config.SEARCH_URL_ITEM_KEYWORD}=${initialParams.keyword}`;
    } else {
      finalParams.keyword = `${config.SEARCH_URL_ITEM_KEYWORD}-${initialParams.keyword}`;
    }
    delete initialParams.searchKeywordParamFormat;
    delete initialParams.keyword;
  }

  if (!isEmpty(initialParams.year)) {
    let year = [initialParams.year.min, bt.DEFAULT_MAX_YEAR + 1];

    if (initialParams.year.max && initialParams.year.max < bt.DEFAULT_MAX_YEAR + 1) {
      year[1] = initialParams.year.max;
    }

    finalParams.year = config.SEARCH_URL_ITEM_YEAR + '-' + year.join(',');

    delete initialParams.year;
  }

  if (initialParams.fuel) {
    const translatedFuel = tr(messages.fuelTypeFacet[initialParams.fuel]);
    finalParams.fuel = `${config.SEARCH_URL_ITEM_FUEL}-${translatedFuel.toLowerCase()}`;
    delete initialParams.fuel;
  }

  if (initialParams.category) {
    const translatedCategory = tr(messages.categoryFacet[initialParams.category]);
    finalParams.category = `${config.SEARCH_URL_ITEM_CATEGORY}-${translatedCategory.toLowerCase()}`;
    delete initialParams.category;
  }

  if (!isEmpty(initialParams.country)) {
    if (initialParams.country !== 'all'){
      finalParams.country = getCountryURLFromCode(initialParams.country.toLowerCase(), overrideLocale);
    }
    delete initialParams.country;
  }

  if (initialParams.city) {
    if (initialParams.city.length > 0) {
      finalParams.city = `${config.SEARCH_URL_ITEM_CITY}-${initialParams.city.join('+')}`;
    }
    delete initialParams.city;
  }

  if (!isEmpty(initialParams.price)) {
    if (initialParams.price.max && initialParams.price.max !== bt.SLIDER_MAX_VALUE) {
      finalParams.price = `${config.SEARCH_URL_ITEM_PRICE}-${initialParams.price.min || 0},${initialParams.price.max}`;
    } else {
      finalParams.price = `${config.SEARCH_URL_ITEM_PRICE}-${initialParams.price.min || 0}`;
    }
    delete initialParams.price;
  }

  if (!isEmpty(initialParams.powerhp)) {
    finalParams.powerhp = `${config.SEARCH_URL_ITEM_POWER_HP}-${initialParams.powerhp.min || 0}`;
    if (initialParams.powerhp.max && initialParams.powerhp.max !== bt.SLIDER_MAX_VALUE) {
      finalParams.powerhp = `${finalParams.powerhp},${initialParams.powerhp.max}`;
    }
    delete initialParams.powerhp;
  }

  if (!isEmpty(initialParams.region)) {
    if (initialParams.region !== 'all'){
      finalParams.region = `${config.SEARCH_URL_ITEM_REGION}-${initialParams.region.toLowerCase()}`;
    }
    delete initialParams.region;
  }

  if (!isEmpty(initialParams.subdivision)) {
    if (initialParams.subdivision !== 'all') {
      const country = ((urlProps && urlProps.country) ? urlProps.country : get(getConfig(), 'country')).toLowerCase();
      const subdivision = initialParams.subdivision.toLowerCase();
      const subdivisionURLCode = getSubdivisionURLFromCode(country, subdivision, overrideLocale);
      finalParams.subdivision = `${config.SEARCH_URL_ITEM_SUBDIVISION}-${subdivisionURLCode}`;
    }
    delete initialParams.subdivision;
  }

  if (initialParams.page) {
    if (newSearch) {
      delete initialParams.page;
      delete initialParams.pageSize;
    }
    else {
      if (initialParams.page !== '1' && initialParams.page !== 1) {
        finalParams.page = `${config.SEARCH_URL_ITEM_PAGE}-${initialParams.page}`;
      }
      delete initialParams.page;
      delete initialParams.pageSize;
    }
  }

  if (initialParams.forSale) {
    if (initialParams.forSale !== 'all') {
      finalParams.by = `${config.SEARCH_URL_ITEM_BY}-${tr(messages.forSaleFacet[initialParams.forSale])}`;
    }
    delete initialParams.forSale;
  }

  if (initialParams.owner) {
    finalParams.owner = initialParams.owner;
    delete initialParams.owner;
  }

  for (let key in initialParams) {
    if (initialParams[key] !== bt.DEFAULT_REFINE_SEARCH[key] && initialParams[key] &&
        !(typeof (bt.DEFAULT_REFINE_SEARCH[key]) === 'object' && isEmpty(bt.DEFAULT_REFINE_SEARCH[key]))) {
      const translatedKey = has(messages.search, key)
        ? tr(messages.search[key])
        : (key.charAt(0).toLowerCase() + key.slice(1));
      finalParams[key] = `${translatedKey}-${initialParams[key]}`;
    }
  }

  let searchPattern = bt.GENERATE_ENGINES_SEARCH_URL_PATTERN;
  if (finalParams.owner) {
    const dealerStr = tr(messages.dealerPrefix);
    searchPattern = getEnginesDealerGalleryPattern(getConfig(), bt, finalParams.owner, dealerStr);
  }

  if (removeLastSlash) {
    return generatePath(searchPattern, finalParams).slice(0,-1);
  }

  return generatePath(searchPattern, finalParams);

};

export const parseSubdivisionParams = (subdivision = '') => {
  const locale = getCurrentLocale();
  initializeGlobalSubdivisionsURLs(locale);
  if (bts().SEARCH_URL_SUBDIVISION_PATTERN.test(subdivision)) {
    const matches = bts().SEARCH_URL_SUBDIVISION_PATTERN.exec(subdivision);
    let twoLetterSubdivision = matches[1].split('|');
    if (!global.url) {
      twoLetterSubdivision = twoLetterSubdivision.map(subdivision => { return subdivision.toUpperCase(); });
      return {
        subdivision: twoLetterSubdivision[0] //TODO add some validation to this data.
      };
    }
    for (const subdivisionElement of global.url[locale].subdivisions ) {
      if (twoLetterSubdivision.includes(subdivisionElement.url)){
        const subdivisionCode = subdivisionElement.code.toUpperCase().split('-')[1];
        return {
          subdivision: subdivisionCode
        };
      }
      if (twoLetterSubdivision[0] === subdivisionElement.code.toLowerCase().split('-')[1]) {
        const subdivisionCode = subdivisionElement.code.toUpperCase().split('-')[1];
        return {
          subdivision: subdivisionCode
        };
      }
    }
    twoLetterSubdivision = twoLetterSubdivision.map(subdivision => { return subdivision.toUpperCase(); });
    return {
      subdivision: twoLetterSubdivision[0] //TODO add some validation to this data.
    };
  }
  return {};
};

export const parseRegionParams = (region = '') => {
  if (bts().SEARCH_URL_REGION_PATTERN.test(region)) {
    const matches = bts().SEARCH_URL_REGION_PATTERN.exec(region);
    return {
      region: matches[1]//TODO add some validation to this data.
    };
  }
  return {};
};

export const parseReplaceRegionParams = (region = '') => {
  if (bts().SEARCH_URL_REGION_PATTERN.test(region)) {
    const matches = bts().SEARCH_URL_REGION_PATTERN.exec(region);
    return {
      region: matches[1]//TODO add some validation to this data.
    };
  }
  return {};
};

export const parseCountryParams = (country = '') => {
  country = country ? getCountryCodeFromURL(country) : country;
  if (bts().SEARCH_URL_COUNTRY_PATTERN.test(country)) {
    const matches = bts().SEARCH_URL_COUNTRY_PATTERN.exec(country);
    return {
      country: matches[1].toUpperCase()//TODO add some validation to this data.
    };
  }
  return {};
};

export const parseReplaceCountryParams = (country = '') => {
  country = country ? getCountryCodeFromURL(country) : country;
  if (bts().SEARCH_URL_COUNTRY_PATTERN.test(country)) {
    const matches = bts().SEARCH_URL_COUNTRY_PATTERN.exec(country);
    return {
      country: matches[1].toUpperCase()//TODO add some validation to this data.
    };
  }
  return {};
};

export const parseCityParams = (city = '') => {
  if (bts().SEARCH_URL_CITY_PATTERN.test(city)) {
    const matches = bts().SEARCH_URL_CITY_PATTERN.exec(city);
    let cityValue = matches[1].split('+');
    return {
      city: cityValue
    };
  }
  return {};
};

export const parseReplaceCityParams = (city = '') => {
  if (bts().SEARCH_URL_CITY_PATTERN.test(city)) {
    const matches = bts().SEARCH_URL_CITY_PATTERN.exec(city);
    let cityValue = unslugify(matches[1], '-', ' ').split('+');
    return {
      city: cityValue.join(',')
    };
  }
  return {};
};

export const parseLegacyMakeModelParams = (make = '', model = '') => {
  if (bts().SEARCH_URL_MAKE_PATTERN.test(make)) {
    const makeMatches = bts().SEARCH_URL_MAKE_PATTERN.exec(make);
    const makeValue = unslugify(makeMatches[1], ' ', '-');
    const modelMatches = model ? bts().SEARCH_URL_MODEL_PATTERN.exec(model) : '';
    let modelValue = [];
    if (modelMatches) {
      modelValue = [unslugify(modelMatches[1], ' ', '-')];
    }
    return {
      makeModel: {
        [makeValue]: modelValue
      }
    };
  }
  return {};
};

export const parseReplaceLegacyMakeModelParams = (make = '', model = '') => {
  if (bts().SEARCH_URL_MAKE_PATTERN.test(make)) {
    const makeMatches = bts().SEARCH_URL_MAKE_PATTERN.exec(make);
    const makeValue = unslugify(makeMatches[1], ' ', '-');
    const modelMatches = model ? bts().SEARCH_URL_MODEL_PATTERN.exec(model) : '';
    let modelValue = [];
    if (modelMatches) {
      modelValue = [unslugify(modelMatches[1], ' ', '-')];
    }
    return {
      multiFacetedMakeModel: formatMultiArrayForURL([[makeValue, modelValue]])
    };
  }
  return {};
};

export const parseMakeModelParams = (makeModel) => {
  if (bts().SEARCH_URL_MAKE_MODEL_PATTERN.test(makeModel)) {
    const matches = bts().SEARCH_URL_MAKE_MODEL_PATTERN.exec(makeModel);
    return {
      makeModel: multiFacetUrlToObject(matches[1], true, '+')
    };
  }
  return {};
};

export const parseReplaceMakeModelParams = (makeModel = '') => {
  if (bts().SEARCH_URL_MAKE_MODEL_PATTERN.test(makeModel)) {
    const matches = bts().SEARCH_URL_MAKE_MODEL_PATTERN.exec(makeModel);
    return {
      multiFacetedMakeModel: formatMultiArrayForURL(multiFacetUrlToArray(matches[1], '+'))
    };
  }
  return {};
};

export const parseCategoryParams = (category = '') => {
  if (bts().SEARCH_URL_CATEGORY_PATTERN.test(category)) {
    return {
      category: mappedValue(category.substring(category.indexOf('-') + 1).toLowerCase(), messages.categoryFacet)
    };
  }
  return { category: '' };
};

export const parseReplaceCategoryParams = (category = '') => {
  if (bts().SEARCH_URL_CATEGORY_PATTERN.test(category)) {
    return {
      category: mappedValue(category.substring(category.indexOf('-') + 1).toLowerCase(), messages.categoryFacet)
    };
  }
  return {};
};

export const parsePageParams = (page = '') => {
  let def = { page: '1', pageSize: '28' };
  if (bts().SEARCH_URL_PAGE_PATTERN.test(page)) {
    const matches = bts().SEARCH_URL_PAGE_PATTERN.exec(page);
    return {
      page: matches[1],
      pageSize: '28'
    };
  }
  return def;
};

export const parseSortParams = (sort = '') => {
  const matches = bts().SEARCH_URL_SORT_PATTERN.exec(sort);
  if (matches) {
    const [sortBy, sortOrder] = matches[1].split(':');
    return { sort: `${mappedValue(sortBy, messages.search)}:${mappedValue(sortOrder, messages.sortFacet)}` };
  }
  return { sort: undefined };
};

export const parseReplaceSortParams = (sort = '') => {
  const matches = bts().SEARCH_URL_SORT_PATTERN.exec(sort);
  if (matches) {
    const [sortBy, sortOrder] = matches[1].split(':');
    const sortEng = `${mappedValue(sortBy, messages.search)}:${mappedValue(sortOrder, messages.sortFacet)}`;
    return { sort: sortTypeMap[sortEng] || 'year-desc' };
  }
  return { sort: sortTypeMap[getDefaultEnginesSort()] };
};

export const parseKeywordParams = (keyword = '') => {
  if (bts().SEARCH_URL_KEYWORD_PATTERN.test(keyword)) {
    const matches = bts().SEARCH_URL_KEYWORD_PATTERN.exec(keyword);
    return {
      keyword: matches[1]
    };
  }
  return { keyword: '' };
};

export const parseReplaceKeywordParams = (keyword = '') => {
  if (bts().SEARCH_URL_KEYWORD_PATTERN.test(keyword)) {
    const matches = bts().SEARCH_URL_KEYWORD_PATTERN.exec(keyword);
    return {
      keyword: matches[1]
    };
  }
  return {};
};

export const parseConditionParams = (condition = '') => {
  if (bts().SEARCH_URL_CONDITION_PATTERN.test(condition)) {
    const matches = bts().SEARCH_URL_CONDITION_PATTERN.exec(condition);
    return {
      condition: mappedValue(matches[1], messages.conditionFacet)
    };
  }
  return { condition: 'any' };
};

export const parseReplaceConditionParams = (condition = '') => {
  const matches = bts().SEARCH_URL_CONDITION_PATTERN.exec(condition);
  if (matches) {
    return { condition: mappedValue(matches[1], messages.conditionFacet) };
  }
  return {};
};

export const parseYearParams = (year = '') => {
  if (bts().SEARCH_URL_YEAR_PATTERN.test(year)) {
    const matches = bts().SEARCH_URL_YEAR_PATTERN.exec(year);
    const ret = { year: {} };
    if (matches[1]){
      ret.year.min = matches[1];
    }
    if (matches[2]){
      ret.year.max = matches[2];
    }
    return ret;
  }
  return {};
};

export const parseReplaceYearParams = (year = '') => {
  if (bts().SEARCH_URL_YEAR_PATTERN.test(year)) {
    const matches = bts().SEARCH_URL_YEAR_PATTERN.exec(year);
    return {
      year: `${matches[1] || ''}-${matches[2] || ''}`
    };
  }
  return {};
};

export const parseFuelParams = (fuelType = '') => {
  if (bts().SEARCH_URL_FUEL_PATTERN.test(fuelType)) {
    const matches = bts().SEARCH_URL_FUEL_PATTERN.exec(fuelType);
    return {
      fuel: mappedValue(matches[1].toLowerCase(), messages.fuelTypeFacet)
    };
  }
  return { fuel: '' };
};

export const parseReplaceFuelParams = (fuelType = '') => {
  if (bts().SEARCH_URL_FUEL_PATTERN.test(fuelType)) {
    const matches = bts().SEARCH_URL_FUEL_PATTERN.exec(fuelType);
    return {
      fuel: mappedValue(matches[1].toLowerCase(), messages.fuelTypeFacet)
    };
  }
  return {};
};

export const parsePriceParams = (price = '') => {
  if (bts().SEARCH_URL_PRICE_PATTERN.test(price)) {
    const matches = bts().SEARCH_URL_PRICE_PATTERN.exec(price);
    let value = {min: matches[1]};
    if (matches[2]) {
      value.max = matches[2];
    }
    return {
      price: value,
    };
  }
  return {};
};

export const parseReplacePriceParams = (price = '') => {
  if (bts().SEARCH_URL_PRICE_PATTERN.test(price)) {
    const matches = bts().SEARCH_URL_PRICE_PATTERN.exec(price);
    let value = `${matches[1]}-`;
    if (matches[2]) {
      value += `${matches[2]}`;
    }
    return {
      price: value,
      currency: getCurrencyCode(),
    };
  }
  return {};
};

export const parseHorsePowerParams = (powerhp = '') => {
  if (bts().SEARCH_URL_POWER_HP_PATTERN.test(powerhp)) {
    const matches = bts().SEARCH_URL_POWER_HP_PATTERN.exec(powerhp);
    let value = { min: matches[1] };
    if (matches[2]) {
      value.max = matches[2];
    }
    return {
      powerhp: value,
    };
  }
  return {};
};

export const parseReplaceHorsePowerParams = (powerhp = '') => {
  if (bts().SEARCH_URL_POWER_HP_PATTERN.test(powerhp)) {
    const matches = bts().SEARCH_URL_POWER_HP_PATTERN.exec(powerhp);
    let value = `${matches[1]}-`;
    if (matches[2]) {
      value += `${matches[2]}`;
    }
    return {
      powerhp: value,
    };
  }
  return {};
};

export const parseModalParams = (modal = '') => {
  if (bts().SEARCH_URL_MODAL_PATTERN.test(modal)) {
    const matches = bts().SEARCH_URL_MODAL_PATTERN.exec(modal);
    let modals = matches[1].split('+');
    return {
      modal: modals
    };
  }
};

export const parseByParams = (by = '') => {
  if (bts().SEARCH_URL_BY_PATTERN.test(by)) {
    const matches = bts().SEARCH_URL_BY_PATTERN.exec(by);
    return {
      forSale: mappedValue(matches[1], messages.forSaleFacet)
    };
  }
};

export const parseReplaceByParams = (by = '') => {
  if (bts().SEARCH_URL_BY_PATTERN.test(by)) {
    const matches = bts().SEARCH_URL_BY_PATTERN.exec(by);
    return {
      sellerType: mappedValue(matches[1], messages.forSaleFacet),
    };
  }
  return {};
};

export const parseOwnerParams = (owner = '') => {
  if (bts().BRANDED_SEARCH_URL_OWNER_PATTERN.test(owner)) {
    return {
      owner
    };
  }
  return {};
};

export const parseReplaceOwnerParams = (owner = '') => {
  if (bts().BRANDED_SEARCH_URL_OWNER_PATTERN.test(owner)) {
    const matches = bts().BRANDED_SEARCH_URL_OWNER_PATTERN.exec(owner);
    const ownerId = matches[3];
    return {
      ownerId
    };
  }
  return {};
};

export const getEnginesSearchUrlPattern = (url, isBranded) => {
  const {ENGINES_BRANDED_SEARCH_URL_PATTERN, ENGINES_SEARCH_URL_PATTERN, ENGINES_DEALER_GALLERY_URL_PATTERN} = bts();
  if (!isBranded) {
    return ENGINES_SEARCH_URL_PATTERN;
  }
  const dealerStr = t(messages.dealerPrefix);
  const clearedPattern = ENGINES_DEALER_GALLERY_URL_PATTERN.replace(/:owner.+/, `${dealerStr}-`);
  const re = new RegExp(clearedPattern);
  return re.test(url) ? ENGINES_DEALER_GALLERY_URL_PATTERN : ENGINES_BRANDED_SEARCH_URL_PATTERN;
};

export const parseSearchParams = (url, isBranded = false) => {
  if (!url) {return {};}
  const searchPattern = getEnginesSearchUrlPattern(url, isBranded);
  let { params } = matchPath(decodeURI(url), searchPattern);
  return {
    ...parseSubdivisionParams(params.subdivision),
    ...parseReplaceRegionParams(params.region),
    ...parseReplaceCountryParams(params.country),
    ...parseReplaceCityParams(params.city),
    ...parseReplaceLegacyMakeModelParams(params.make, params.model),
    ...parseReplaceMakeModelParams(params.makeModel),
    ...parseReplaceCategoryParams(params.category),
    ...parsePageParams(params.page),
    ...parseReplaceSortParams(params.sort, params.postalCode, 'price:desc'),
    ...parseReplaceKeywordParams(params.keyword),
    ...parseReplaceConditionParams(params.condition),
    ...parseReplaceYearParams(params.year),
    ...parseReplaceFuelParams(params.fuel),
    ...parseReplacePriceParams(params.price),
    ...parseReplaceHorsePowerParams(params.powerhp),
    ...parseReplaceByParams(params.by),
    ...parseReplaceOwnerParams(params.owner)
  };
};

export const parseSearchAppParams = (url, isBranded = false) => {
  if (!url) {return {};}
  const searchPattern = getEnginesSearchUrlPattern(url, isBranded);
  let { params } = matchPath(decodeURI(url), searchPattern);
  return getDefaultParams(params);
};

export const getDefaultParams = (params) => {

  let parsed = {
    ...parseSubdivisionParams(params.subdivision),
    ...parseRegionParams(params.region),
    ...parseCountryParams(params.country),
    ...parseCityParams(params.city),
    ...parseLegacyMakeModelParams(params.make, params.model),
    ...parseMakeModelParams(params.makeModel),
    ...parseCategoryParams(params.category),
    ...parsePageParams(params.page),
    ...parseSortParams(params.sort),
    ...parseConditionParams(params.condition),
    ...parseYearParams(params.year),
    ...parseFuelParams(params.fuel),
    ...parsePriceParams(params.price),
    ...parseHorsePowerParams(params.powerhp),
    ...parseModalParams(params.modal),
    ...parseByParams(params.by),
    ...parseOwnerParams(params.owner),
    ...parseKeywordParams(params.keyword),
  };

  let defaults = {
    ...bts().DEFAULT_REFINE_SEARCH
  };

  defaults = Object.assign(defaults, parsed);
  return defaults;
};

export const reduceURLForRedirect = (props) => {
  let params = get(props, 'match.params', {});
  let lastParam;
  let modified = false;
  forEach(params, (value, key) => {
    if (!bts().INDEXABLE_PARAMS.includes(key)) {
      if (params[key]) {
        params[key] = undefined;
        modified = true;
      }
    }
  });
  let reducedUrl = generateSearchPath({}, getDefaultParams(params), true);
  if (!modified) {
    bts().INDEXABLE_PARAMS.forEach(matchParam => {
      if (params[matchParam]) {
        lastParam = matchParam;
      }
    });
    delete params[lastParam];
    reducedUrl = generateSearchPath({}, getDefaultParams(params, lastParam), true);
  }

  return reducedUrl;

};

export const getActiveParams = (params) => {
  const defaults = getDefaultParams({});
  const active = Object.entries(params).filter(([key, value]) => {
    return defaults[key] !== value;
  });

  const allActive = active
    .reduce((object, [key, value]) => ({ ...object, [key]: value }), {});

  return allActive;
};

export const unhyphenateUrlComponents = (string) => {
  string = string.toLowerCase();
  string = string.split('--').join('..');
  string = string.split('-').join(' ');
  string = string.split('$').join('&');
  string = unslugify(string, '..', '-');
  return string;
};

const formatCountry = (facetKey, selectedValues, noFacet, facetMeta, defaultParams) => {
  const newValueSlug = defaultParams[facetKey];
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);
  const formattedValue = t(messages.countries[selectedValues]);
  const isFormatted = true;
  return { ...facetMeta, key: facetKey, href, value: formattedValue, newValue: newValueSlug, isFormatted };
};

const formatCity = (facetKey, selectedValues, noFacet, facetMeta, defaultParams) => {
  return selectedValues.map((facetValue) => {
    const newValueSlug = without(selectedValues, facetValue);
    const formattedValue = unhyphenateUrlComponents(facetValue);
    const indexKey = `${facetKey}.${facetValue}`;
    const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);
    return { ...facetMeta, href, key: facetKey, indexKey, value: formattedValue, newValue: newValueSlug };
  });
};

export const getFormattedMakeForFacet = (selectedMakeSlug, selectedMakeModels, makeModel) => {
  const selectedMake = makeModel.find(({ value: makeFormattedName }) => {
    const slugMake = normalizeMake(hyphenateUrlComponents(makeFormattedName));
    return has(selectedMakeModels, slugMake) && slugMake === selectedMakeSlug;
  });
  return get(selectedMake, 'value');
};

// eslint-disable-next-line max-len
const formatModel = (facetKey, selectedValues, noFacet, facetMeta, defaultParams, facetValue, subFacetValue, formattedMake, makeModel) => {
  const newValueSlug = {
    ...omit(selectedValues, facetValue),
    ...toggleSubFacet(facetValue, subFacetValue, selectedValues)
  };
  let formattedValue;
  let isFormatted;

  const makeObj = makeModel.find(e=> hyphenateUrlComponents(e.value) === facetValue)
    || { value: unslugify(facetValue), model: []};
  const modelObj = makeObj.model.find( e=> hyphenateUrlComponents(e.value) ===  subFacetValue )
    || { value: unslugify(subFacetValue)};
  formattedValue = `${formattedMake || makeObj.value} - ${modelObj.value}`;
  isFormatted = !!formattedMake;

  const indexKey = `${facetKey}.${facetValue}.${subFacetValue}`;
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);

  return { ...facetMeta, href, key: facetKey, indexKey, value: formattedValue, newValue: newValueSlug, isFormatted };
};

const formatMake = (facetKey, selectedValues, noFacet, facetMeta, defaultParams, facetValue, formattedMake) => {
  const newValueSlug = omit(selectedValues, facetValue);
  const formattedValue = `${t(messages.all)} ${translateMake(formattedMake || unslugify(facetValue))}`;
  const isFormatted = !!formattedMake;
  const indexKey = `${facetKey}.${facetValue}`;
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);

  return { ...facetMeta, href, key: facetKey, indexKey, value: formattedValue, newValue: newValueSlug, isFormatted };
};

const formatSubdivision = (facetKey, selectedValues, noFacet, facetMeta, defaultParams) => {
  const newValueSlug = defaultParams[facetKey];
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);
  const formattedValue = t(messages.countrySubdivision[selectedValues]);
  const isFormatted = true;
  return { ...facetMeta, key: facetKey, href, value: formattedValue, newValue: newValueSlug, isFormatted };
};

const formatRegion = (facetKey, selectedValues, noFacet, facetMeta, defaultParams) => {
  const newValueSlug = defaultParams[facetKey];
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);
  const formattedValue = t(messages.countryRegions[selectedValues]);
  const isFormatted = true;
  return { ...facetMeta, key: facetKey, href, value: formattedValue, newValue: newValueSlug, isFormatted };
};

const formatDefaultFacets = (facetKey, selectedValues, noFacet, facetMeta, defaultParams) => {
  const newValueSlug = defaultParams[facetKey];
  const href = generateSearchPath({ ...noFacet, [facetKey]: newValueSlug }, defaultParams, true);
  let isFormatted = false;
  let { prefix = '', suffix = '' } = facetMeta;
  if (isObject(selectedValues)) {
    if (selectedValues.min && !selectedValues.max) {
      suffix = '+ ' + suffix;
    } else if (!selectedValues.min && selectedValues.max) {
      prefix = `${t(messages.upTo)} ${prefix}`;
    } else if (!isEmpty(suffix)) {
      suffix = ' ' + suffix;
    }
  }

  let formattedValue = isString(selectedValues) && facetKey !== 'keyword' ? unslugify(selectedValues) : selectedValues;
  if (facetKey === 'condition' || facetKey === 'forSale') {
    formattedValue = t(messages[selectedValues]);
    isFormatted = true;
  }
  if (facetKey === 'category') {
    formattedValue = upperFirst(t(messages.categoryFacet[selectedValues]));
    isFormatted = true;
  }
  if (facetKey === 'fuel') {
    const translatedFuelType = upperFirst(t(messages.fuelTypeFacet[selectedValues]));
    formattedValue = selectedValues === 'lpg' ? translatedFuelType.toUpperCase() : upperFirst(translatedFuelType);
    isFormatted = true;
  }
  if (facetKey === 'sort') {
    const [sortBy, sortOrder] = selectedValues.split(':');
    formattedValue = `${t(messages[sortBy])}:${t(messages.sortFacetValues[sortOrder])}`;
    isFormatted = true;
  }
  if (facetKey === 'keyword') {
    isFormatted = true;
  }

  // eslint-disable-next-line max-len
  return { ...facetMeta, href, key: facetKey, value: formattedValue, newValue: newValueSlug, prefix, suffix, isFormatted };
};

export const getFormattedParamsArray = (active, makeModel = []) => {
  const facetMetaMap = {
    price: {
      [getCurrencyFormat() === 'postfix' ? 'suffix' : getCurrencyFormat()]: getCurrencySymbol(),
      format: 'number',
    }
  };
  const defaultParams = getDefaultParams({});
  return flatten(Object.entries(active).map(([facetKey, selectedValues]) => {
    const facetMeta = { ...facetMetaMap[facetKey], formattedKey: t(messages[facetKey]) };
    const noFacet = omit(active, facetKey);
    switch (facetKey) {
    case 'country':
      return formatCountry(facetKey, selectedValues, omit(noFacet, ['city']), facetMeta, defaultParams);
    case 'city':
      return formatCity(facetKey, selectedValues, noFacet, facetMeta, defaultParams);
    case 'makeModel':
      return flatten(Object.entries(selectedValues).map(([facetValue, subFacets]) => {
        const formattedMake = getFormattedMakeForFacet(facetValue, active.makeModel, makeModel);
        if (subFacets && subFacets.length) {
          return subFacets.map(
            (subFacetValue) => formatModel(facetKey, selectedValues, noFacet, facetMeta, defaultParams,
              facetValue, subFacetValue, formattedMake, makeModel)
          );
        }
        return formatMake(facetKey, selectedValues, noFacet, facetMeta, defaultParams, facetValue, formattedMake);
      }));
    case 'subdivision':
      return formatSubdivision(facetKey, selectedValues, omit(noFacet, ['city']), facetMeta, defaultParams);
    case 'region':
      return formatRegion(facetKey, selectedValues, omit(noFacet, ['subdivision']), facetMeta, defaultParams);
    default:
      return formatDefaultFacets(facetKey, selectedValues, noFacet, facetMeta, defaultParams);
    }
  }));
};

export const getSubdivisionURLFromCode = (countryCode, code, overrideLocale) => {
  if (countryCode && code) {
    const locale = overrideLocale ? overrideLocale : getCurrentLocale();
    initializeGlobalSubdivisionsURLs(locale);
    const urls = global.url[locale].subdivisions.filter(subdivision => {
      return subdivision.code === `${countryCode}-${code}`;
    });
    return (urls.length > 0) ? `${urls[0].url}` : code;
  }
  return code;
};

export const initializeGlobalSubdivisionsURLs = (locale = '') => {
  if (locale.length === 2) {
    if (!get(global, `url.${locale}`)) { set(global, `url.${locale}`, {}); }
    if (!global.url[locale].subdivisions) {
      // Can't use this as this only contains the information for the current language, and we need this to be dynamic.
      const subdivisionsFromTranslation = require('../language').translationMessages[locale];
      let subdivisions = [];
      let subdivision = '';
      for (let prop in subdivisionsFromTranslation) {
        if (prop === 'routes.search.item.subdivision') { subdivision = subdivisionsFromTranslation[prop]; }
        if (prop.match(/app.countrySubdivision.([a-zA-Z0-9]{2}-[a-zA-Z0-9]{2,5})/g)) {
          try {
            const subdivisionTranslatedName = hyphenateUrlComponents(subdivisionsFromTranslation[prop], true, true);
            subdivisions.push({
              code: prop.replace('app.countrySubdivision.', '').toLowerCase(),
              url: subdivisionTranslatedName.trim()
            });
          } catch (e) {
            // Comment to avoid the empty block statement :(
          }
        }
      }
      global.url[locale].subdivision = subdivision;
      global.url[locale].subdivisions = subdivisions;
    }
  }
};
